// @flow
import * as React from "react"
import Routes from "./Routes"

const AccountPage = () => <Routes />

export default AccountPage



// WEBPACK FOOTER //
// ./src/pages/Account/index.js